module.exports = "/shiftTasks/components/taskTemplates/taskTemplatesPickerField-9259d0.html";